import * as types from '../../../../constants/ActionNameConstants';

const initialState = {
  loading: false,
  error: null,
};

const RemoveUnusedSpeakerReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.REMOVE_UNUSED_SPEAKERS_REQUEST:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.REMOVE_UNUSED_SPEAKERS_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.REMOVE_UNUSED_SPEAKERS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default RemoveUnusedSpeakerReducer;
